import type { AwardItem } from "../../data/site";
import { Card } from "../ui/Card";
import "./awards.css";

export function Awards({ items }: { items: AwardItem[] }) {
  return (
    <div className="awards">
      {items.map((a) => (
        <Card key={`${a.title}-${a.year ?? ""}`}>
          <div className="awards__row">
            <div className="awards__title">{a.title}</div>
            {a.year ? <div className="awards__year">{a.year}</div> : null}
          </div>
          {a.note ? <div className="awards__note">{a.note}</div> : null}
        </Card>
      ))}
    </div>
  );
}

